<template>
    <div>
        Display other content for the following {{languageLabel}}: {{summary}}.
    </div>
</template>

<script>
    import listSummary from '@/common/helpers/list-summary';
    import _ from '@/common/helpers';
    import LANGUAGES from '@/data/languages';
    import BaseActionSummary from '../base-action-summary';

    export default {
        name: 'display-other-choices-summary',
        extends: BaseActionSummary,
        computed: {
            languageLabel() {
                return _.pluralize('language', this.action.choices.length);
            },
            summary() {
                const present = this.action.choices.map(v => v.langIso);
                const list = LANGUAGES
                    .filter(v => present.includes(v.langIso))
                    .map(v => v.name);
                return listSummary(list, 3);
            },
        },
    };
</script>
